import React, {
  FC,
  useEffect,
  useMemo,
} from 'react';
import cx from 'classnames';
import { routes, URL, isLayoutMock } from 'appConstants';
import { ButtonV4 } from 'components';
import { useRequest } from 'hooks';
import {
  dateToUiFormat,
  _t_back,
  _t,
  parseNewsListResponse,
} from 'utils';
import type { News, GetResponse } from 'types';

import styles from './styles.module.scss';

type Props = {
  className?: string,
};

const FALLBACK_NEWS = [
  {
    id: 1,
    slug: 'demo-news',
    pubdate: '2026-02-16',
    title: 'Положение о порядке оказания меры поддержки по проведению бизнес-миссий',
  },
  {
    id: 2,
    slug: '',
    pubdate: '2026-02-16',
    title: 'Положение о конгрессно-выставочных мероприятиях',
  },
  {
    id: 3,
    slug: '',
    pubdate: '2025-04-09',
    title: 'Опрос о мерах поддержки «Международная кооперация и экспорт»',
  },
  {
    id: 4,
    slug: '',
    pubdate: '2025-03-06',
    title: 'Объем поддержанного экспорта клиентов платформы «Мой экспорт» в 2024 году превысил 155 млрд рублей',
  },
];

const formatDate = (value: string) => {
  if (/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
    return value;
  }
  return dateToUiFormat(value);
};

const MainNews: FC<Props> = ({ className }) => {
  const {
    data,
    request,
  } = useRequest<GetResponse<News[]> | News[]>();
  const layoutMock = isLayoutMock();

  useEffect(() => {
    if (layoutMock) {
      return;
    }
    request({
      method: 'GET',
      url: URL.NEWS.GET,
    });
  }, []);

  const parsedNews = useMemo(() => parseNewsListResponse(data, {
    limit: 4,
    offset: 0,
  }), [data]);

  const apiItems = layoutMock ? [] : parsedNews.results;

  const items = apiItems.length
    ? apiItems.map((item) => ({
      id: item.id,
      slug: item.slug,
      pubdate: item.pubdate,
      title: _t_back(item, 'title'),
    }))
    : FALLBACK_NEWS.map((item) => ({
      ...item,
      slug: item.slug || `demo-news-${item.id}`,
    }));

  return (
    <section className={cx(styles.wrap, className)}>
      <div className={styles.inner}>
        <div className={styles.head}>
          <h2 className={styles.title}>{_t('Новости')}</h2>
          <ButtonV4
            to={routes.media.news.root}
            label="Смотреть все новости"
            variant="outline"
            tone="onLight"
            size="sm"
            className={styles.allBtn}
          />
        </div>

        <ul className={styles.grid}>
          {items.map((news, index) => {
            const to = `${routes.media.root}/${news.slug || news.id}`;
            const featured = index === 0;

            return (
              <li
                key={news.id}
                className={cx(styles.card, featured && styles.cardFeatured)}
              >
                <span className={styles.badge}>{_t('НОВОСТИ')}</span>
                <div className={styles.body}>
                  <time className={styles.date} dateTime={news.pubdate}>
                    {formatDate(news.pubdate)}
                  </time>
                  <h3 className={styles.cardTitle}>{news.title}</h3>
                  <ButtonV4
                    to={to}
                    label="Подробнее"
                    variant="outline"
                    tone={featured ? 'onDark' : 'onLight'}
                  />
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default MainNews;
